"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT_PROJECTS_TITLE = exports.SELECT_CEO_TITLE = exports.SELECT_PRELUDE_TITLE = exports.SELECT_CORPORATION_TITLE = void 0;
exports.SELECT_CORPORATION_TITLE = 'Select corporation';
exports.SELECT_PRELUDE_TITLE = 'Select 2 Prelude cards';
exports.SELECT_CEO_TITLE = 'Select CEO';
exports.SELECT_PROJECTS_TITLE = 'Select initial cards to buy';
